import React, { useState } from "react";
import stylelist from "stylelist";

const InputField = (props) => {
    let checked = false;

    return <li>
        <label className={stylelist([props.active,'active'])} onClick={()=>props.setValue(props.value['1'])}>
            <i className={`icon-${props.icon}`}/>
            <span className="number">
                {props.value['0']}
            </span>
        </label>
    </li>
}
export default InputField;